/**
 * Typ custom akcí používaných v mapovém editoru.
 */
export enum ActionTypes {
    /**
     * Zobrazení/skrytí tabulky atributů.
     */
    SHOW_FEAT_TABLE = 'SHOW_FEAT_TABLE',

    /**
     * Nastavení rozsahu features.
     */
    EXTENT_FEATURES = 'EXTENT_FEATURES',

    /**
     * Povolení/zakázání nástrojů.
     */
    TOOLS_ENABLED = 'TOOLS_ENABLED',

    /**
     * Označení vrstvy pro editaci.
     */
    CHECKED_LAYER_EDIT = 'CHECKED_LAYER_EDIT',

    /**
     * Navigace na editaci uživatelské vrstvy.
     */
    NAVIGATE_TO_USER_LAYER_EDIT = 'NAVIGATE_TO_USER_LAYER_EDIT',

    /**
     * Navigace na uživatelskou akci.
     */
    NAVIGATE_TO_USER_ACTION = 'NAVIGATE_TO_USER_ACTION',

    /**
     * Změna vzdálenosti.
     */
    DISTANCE_CHANGED = 'DISTANCE_CHANGED',

    /**
     * Výběr více features.
     */
    MULTIPLE_FEATURES_SELECT = 'MULTIPLE_FEATURES_SELECT',

    /**
     * Síťová chyba.
     */
    NETWORK_ERROR = 'NETWORK_ERROR',

    /**
     * Zakázání/povolení.
     */
    DISABLE = 'DISABLE',

    /**
     * Optimální měřítko pro tisk.
     */
    OPTIMAL_PRINT_SCALE = 'OPTIMAL_PRINT_SCALE',

    /**
     * Přidání externí vrstvy do katalogu.
     */
    EXTERNAL_LAYER_TO_CATALOG = 'EXTERNAL_LAYER_TO_CATALOG',

    /**
     * Zobrazení toaster notifikace.
     */
    SHOW_TOASTER = 'SHOW_TOASTER',

    /**
     * Změna středu a přiblížení mapy.
     */
    CENTER_AND_ZOOM_CHANGED = 'CENTER_AND_ZOOM_CHANGED',
}
